import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ComboBox from 'scenes/ExpenseTracking/components/ComboBox';
import { selectWorkCalendarEmployersArray } from 'scenes/WorkDemo/store/selectors/base-work-calendar.selectors';
import { selectEmployerTypeProjects } from 'store/projects/selectors/projectsSelectors';
import { selectIsDialogResourcesLoading } from 'store/records/selectors/records.selectors';
import { selectProjectResources } from 'store/resources/selectors/resources.selectors';
import sortByName from 'utils/sortByName';

export const ProjectResourcesSelect = ({
  projectId,
  selectedResourceId,
  setAttributes,
  isPermissionsToEdit,
  isRecordApprovedAndUserNotAdmin,
  updatesPending,
  sentToApproval,
  emptyOption = false,
  emptyAsNull = false,
  label,
}) => {
  const projectResources = useSelector((state) =>
    selectProjectResources(state, projectId)
  );

  const workCalendarEmployers = useSelector(selectWorkCalendarEmployersArray);

  const employerProjects = useSelector(selectEmployerTypeProjects);

  const isResourcesLoading = useSelector(selectIsDialogResourcesLoading);

  const { t } = useTranslation('common');

  return (
    <ComboBox
      items={projectResources
        .sort((a, b) => sortByName(a, b, 'lastName'))
        .map((resource) => {
          const resourceEmployer = [
            ...workCalendarEmployers,
            ...employerProjects,
          ].find(
            (employerProject) =>
              employerProject.business_id === resource.employerBusinessId
          );

          if (resourceEmployer && resourceEmployer.name) {
            return {
              ...resource,
              name: `${resourceEmployer.name} / ${resource.lastName} ${resource.firstName}`,
            };
          } else {
            return {
              ...resource,
              name: `MyLixani (Ei työnantajaa) / ${resource.lastName} ${resource.firstName}`,
            };
          }
        })}
      selected={selectedResourceId}
      onChange={(value) => setAttributes({ resource: value })}
      label={label || t('common.person')}
      emptyOption={emptyOption}
      emptyAsNull={emptyAsNull}
      disabled={
        isResourcesLoading ||
        !isPermissionsToEdit ||
        isRecordApprovedAndUserNotAdmin ||
        updatesPending ||
        sentToApproval
      }
      loading={isResourcesLoading}
    />
  );
};
